import { createAsyncThunk } from "@reduxjs/toolkit";
import { setErrorSnackBarMessage } from "../systemSlice";
import { errorToHandler } from "../../api/error";
import { RootState } from "app/store";
import { obsApi } from "api";

export const fetchPrometheusMetric = createAsyncThunk(
  "deployments/fetchPrometheusMetric",
  async (metricName: string, { rejectWithValue, getState, dispatch }) => {
    const state = getState() as RootState;
    return obsApi.prometheusMetrics
      .getPrometheusMetrics(metricName, {
        startTime: state.deploymentMetrics.timeInterval,
        topNLimit: state.deploymentPrometheusMetrics.topNLimit,
        bottomNLimit: state.deploymentPrometheusMetrics.bottomNLimit,
      })
      .then((res) => {
        return res.data.results;
      })
      .catch((res) => {
        dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
        return rejectWithValue(res);
      });
  },
);

export const fetchPrometheusTopBottomAvg = createAsyncThunk(
  "deployments/fetchPrometheusMetricV2",
  async (metricName: string, { rejectWithValue, getState, dispatch }) => {
    const state = getState() as RootState;
    return obsApi.prometheusMetrics
      .getPrometheusMetricTopBottomAvg(metricName, {
        startTime: state.deploymentMetrics.timeInterval,
      })
      .then((res) => {
        return res.data;
      })
      .catch((res) => {
        dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
        return rejectWithValue(res);
      });
  },
);

export const fetchPrometheusTopBottomValues = createAsyncThunk(
  "deployments/fetchPrometheusTopBottomValues",
  async (metricName: string, { rejectWithValue, getState, dispatch }) => {
    const state = getState() as RootState;
    return obsApi.prometheusMetrics
      .getPrometheusMetricTopBottomValues(metricName, {
        startTime: state.deploymentMetrics.timeInterval,
      })
      .then((res) => {
        return res.data;
      })
      .catch((res) => {
        dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
        return rejectWithValue(res);
      });
  },
);

export const fetchPrometheusAggregate = createAsyncThunk(
  "deployments/fetchPrometheusAggregate",
  async (metricName: string, { rejectWithValue, getState, dispatch }) => {
    const state = getState() as RootState;
    return obsApi.prometheusMetrics
      .getPrometheusMetricAggregate(metricName, {
        startTime: state.deploymentMetrics.timeInterval,
      })
      .then((res) => {
        return res.data;
      })
      .catch((res) => {
        dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
        return rejectWithValue(res);
      });
  },
);
